<ng-container *ngIf="segmentMiles$ | async; let segmentMiles">
    <div class="sticky-top mat-elevation-z6 equipment-menu">
        <mat-toolbar class="commodity-header-bar bds-toolbar-blue">
            <mat-toolbar-row style="display: flex; align-items: center; width: 100%">
                <span>Segment Miles</span>
                <div style="margin-left: auto">
                    <button
                        mat-stroked-button
                        (click)="save(segmentMilesForm.form)"
                        [disabled]="segmentMiles | any : 'N' : 'isActive'"
                    >
                        <fa-icon [icon]="iconSave"> </fa-icon>
                        Save
                    </button>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <div style="padding-bottom: 10px"></div>
    <bds-segment-miles-form [segmentMiles]="segmentMiles" #segmentMilesForm>
    </bds-segment-miles-form>
</ng-container>
